export default {
  changeTopBarSearchBarMobileActive(context, locale) {
    context.commit('TOPBAR_SEARCHBAR_MOBILE_ACTIVE', locale);
  },
  changeTopBarSearchBarFocus(context, locale) {
    context.commit('TOPBAR_SEARCHBAR', locale);
  },
  changeTopBarNotifyFocus(context, locale) {
    context.commit('TOPBAR_NOTIFY', locale);
  },
  changeTopBarUserPanelFocus(context, locale) {
    context.commit('TOPBAR_USER_PANEL', locale);
  },
  changeTopBarUserFeatureFocus(context, locale) {
    context.commit('TOPBAR_USER_FEATURE', locale);
  },
  changeTopBarHamburgerFocus(context, locale) {
    context.commit('TOPBAR_HAMBURGER', locale);
  },
  userUpdateProfile(context, locale) {
    context.commit('UPDATE_PROFILE', locale);
  },
  userLoginMember(context, locale) {
    context.commit('LOGIN_MEMBER', locale);
  },
  userAuthJwtToken(context, locale) {
    context.commit('USER_AUTH_JWT', locale);
  },
  userUpdateProfileSideEffect(context, locale) {
    context.commit('UPDATE_PROFILE_SIDEEFFECT', locale);
  },
  userUpdateProfileSideEffectPersonal(context, locale) {
    context.commit('UPDATE_PROFILE_SIDEEFFECT_PERSONAL', locale);
  },
};
